/**************************************************************************/
/*** ML Query Builder implemented By Fahad Akbar(fahadakbar24@gmail.com)***/
/**************************************************************************/

angular.module('app.api')
.factory('columnSelectionApi', ['api', function(api) {

	var columnSelectionApi = {
        fetch: (pageId) => api.request('GET', `/api/admin/column-selection/fetch/${pageId}`),
        save: (selectionPayload) => api.request('PUT', '/api/admin/column-selection/save', selectionPayload)
    };
    
	return columnSelectionApi;
}]);


// WEBPACK FOOTER //
// ./scripts/shared/directives/column-selector/api.js